// Paint prerendered public pages before loading their interactive React runtime.
// Product routes start immediately; ordinary links already work in the static HTML.
const hydrate = async () => {
  const [{ StrictMode, startTransition, createElement }, { hydrateRoot }, { StartClient }] =
    await Promise.all([
      import('react'),
      import('react-dom/client'),
      import('@tanstack/react-start/client'),
    ]);

  startTransition(() => {
    hydrateRoot(document, createElement(StrictMode, null, createElement(StartClient)));
  });
};

if (document.querySelector('.site-layout')) {
  requestAnimationFrame(() => setTimeout(() => void hydrate(), 0));
} else {
  void hydrate();
}
